'use client';
import { useEffect } from 'react';

const GoogleAnalyticsScript = () => {
    useEffect(() => {
        // create gtag script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XZN4W9DT2D';
        document.head.appendChild(script);

        // init dataLayer & gtag
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }

        gtag('js', new Date());
        gtag('config', 'G-XZN4W9DT2D');

        // expose gtag globally (optional but recommended)
        window.gtag = gtag;
    }, []);

    return null;
};

export default GoogleAnalyticsScript;
